import { ComponentSize } from '@/interfaces';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const MIN_HEIGHTS: Record<ComponentSize, string> = {
  small: 'min-h-[30px]',
  default: 'min-h-[32px]',
  large: 'min-h-[36px]',
  extra: 'min-h-[42px]',
};

export const HEIGHTS: Record<ComponentSize, string> = {
  small: 'h-[30px]',
  default: 'h-[32px]',
  large: 'h-[36px]',
  extra: 'h-[42px]',
};

export const FONT_SIZES: Record<ComponentSize, string> = {
  small: 'text-sm',
  default: 'text-base',
  large: 'text-base',
  extra: 'text-base',
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
